import React from 'react';
import { Card, Descriptions, Typography, Button, Space, Tag, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useSession } from '@/hooks/useSessions';

const { Title } = Typography;

const SessionDetail: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: session, isLoading } = useSession(id || '');

  if (isLoading) {
    return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }} />;
  }

  if (!session) {
    return <div>Sessão não encontrada</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Space>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/sessions')} />
          <Title level={4} style={{ margin: 0 }}>Detalhes da Sessão</Title>
        </Space>
      </div>

      <Card>
        <Descriptions bordered column={{ xs: 1, sm: 2, lg: 3 }}>
          <Descriptions.Item label="Dispositivo Origem">{session.source_device_name}</Descriptions.Item>
          <Descriptions.Item label="Dispositivo Destino">{session.target_device_name}</Descriptions.Item>
          <Descriptions.Item label="Iniciado por">{session.initiated_by_name}</Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={
              session.status === 'CONNECTED' ? 'green' :
              session.status === 'PENDING' ? 'orange' :
              session.status === 'DISCONNECTED' ? 'blue' : 'red'
            }>
              {session.status === 'CONNECTED' ? 'Conectado' :
               session.status === 'PENDING' ? 'Pendente' :
               session.status === 'DISCONNECTED' ? 'Desconectado' : 'Falhou'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="IP">{session.ip_address}</Descriptions.Item>
          <Descriptions.Item label="Início">
            {new Date(session.started_at).toLocaleString('pt-BR')}
          </Descriptions.Item>
          <Descriptions.Item label="Fim">
            {session.ended_at ? new Date(session.ended_at).toLocaleString('pt-BR') : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Duração">{session.duration || '-'}</Descriptions.Item>
          <Descriptions.Item label="Notas" span={2}>{session.notes || '-'}</Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default SessionDetail;
